import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const getBookingDurationAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  return booking?.durationMins ?? null;
});
